import {
  Container,
  ContentWrapper,
  TopBar,
  GogoxIMG,
  Title,
  mapStyles,
} from '@/modules/track-and-trace/track-and-trace.styles';
import { useTranslation } from 'next-i18next';
import TrackSearch from '@/modules/track-and-trace/track-search/track-search.component';
import { useLazySearchTrackingByOrderIdsQuery } from '@/modules/track-and-trace/track-and-trace.api';
import { useEffect, useState } from 'react';
import TrackRecordCard from '@/modules/track-and-trace/track-record-card/track-record-card.component';
import NoRecordCard from '@/modules/track-and-trace/track-record-card/no-record-card.component';
import { GgxLinearProgressbar } from '@gogovan/entier-web-core/components/ggx-linear-progressbar';
import RegionLanguageSelection from '@/modules/track-and-trace/region-language-selection/region-language-selection.component';
import FloatingChatButton from '@/utilities/reusable-components/button/floating-chat-button/floating-chat-button.component';
import { Dialog } from '@gogovan/entier-web-core/ext/mui/Dialog';
import { useTheme } from '@gogovan/entier-web-core/ext/mui/styles';
import { useMediaQuery } from '@gogovan/entier-web-core/ext/mui/useMediaQuery';
import dynamic from 'next/dynamic';

const Map = dynamic(() => import('@/modules/track-and-trace/track-record-card/map/map.component'), {
  ssr: false,
});

const TrackAndTrace = () => {
  const { t } = useTranslation('common');
  const [reqBody, setReqBody] = useState({ captchaToken: '', orderIds: [], locale: '' });
  const [trackResults, setTrackResults] = useState([]);
  const [mapDialogInfo, setMapDialogInfo] = useState({ open: false, destination: null, driver: null });

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const [trigger, { data, isFetching }] = useLazySearchTrackingByOrderIdsQuery();

  useEffect(() => {
    if (reqBody && reqBody.captchaToken?.length > 0 && reqBody.urlIdentifier) {
      trigger(reqBody);
    }
  }, [reqBody, trigger]);

  useEffect(() => {
    if (data && data.data) {
      setTrackResults([]);
      reqBody.orderIds.forEach((searchId) => {
        if (data.data[searchId]) {
          setTrackResults((oldResult) => [
            ...oldResult,
            <TrackRecordCard
              key={searchId}
              trackingRecords={data.data[searchId]}
              isLoading={isFetching}
              setMapDialogInfo={setMapDialogInfo}
            />,
          ]);
        } else {
          setTrackResults((oldResult) => [...oldResult, <NoRecordCard key={searchId} trackingId={searchId} />]);
        }
      });
    }
  }, [data]);

  return (
    <Container>
      <TopBar>
        <GogoxIMG />
        <RegionLanguageSelection />
      </TopBar>
      <ContentWrapper>
        <Title>{t('track_and_trace')}</Title>
        <TrackSearch setReqBody={setReqBody} isSearching={isFetching} />
        {isFetching && <GgxLinearProgressbar sx={{ margin: '0 48px' }} />}
        {trackResults.map((trackResult) => trackResult)}
      </ContentWrapper>
      <FloatingChatButton />
      <Dialog
        open={mapDialogInfo.open}
        onClose={() => setMapDialogInfo({ open: false, destination: null, driver: null })}
        fullWidth
        maxWidth='lg'
        fullScreen={fullScreen}
      >
        <Map
          isLoading={false}
          destination={mapDialogInfo.destination}
          driver={mapDialogInfo.driver}
          sx={mapStyles(fullScreen)}
          setMapDialogInfo={setMapDialogInfo}
          isFullScreen
        />
      </Dialog>
    </Container>
  );
};

export default TrackAndTrace;
